export const environment = {
  production: true,
  domain: 'https://dev-api-if.brasile.pro',
  mainDomain: 'https://dev-if.brasile.pro',
  stripeKey: 'pk_test_AIUZI6SCnEMsiQiWBNcwxBQ7'
};
